import {
  ADD_USER_ACCOUNT_MODAL_I18N_KEYS
} from '../../../../../features/user-management/components/constants/i18n/AddUserAccountModali18nConstants';
import { MAXIMUM_PASSWORD_LENGTH, MINIMUM_PASSWORD_LENGTH } from '../../../../../common/globalUtils';

export const ADD_USER_ACCOUNT_MODAL_I18N_EN = {
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.add_user]:                 'Add User',
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.edit_user]:                'Edit User',
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.name_label]:               "Name",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.email_label]:              "Email",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.password_label]:           "Password",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.designation_label]:        "Designation",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.invalid_email_format]:     'Invalid email format',
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.invalid_password]:         'Invalid password. Must be between '  + MINIMUM_PASSWORD_LENGTH.toString() + ' and ' + MAXIMUM_PASSWORD_LENGTH.toString() + ' characters.',
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.email_already_exists]:     'Email address already used',
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.new_user_added_header]:    "New User Added!",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.new_user_add_paragraph_1]: "The new user has been added to the new trial.",
    [ADD_USER_ACCOUNT_MODAL_I18N_KEYS.new_user_add_paragraph_2]: "Their login details have been sent to their registered email."
};


// WEBPACK FOOTER //
// ./src/locales/en/features/user_management/components/add_user_account_modal.i18n.en.js